module.exports = __webpack_public_path__ + "img/93.5.COD.2c2f4cb9.png";